import { CreateCustomFormRequest } from '@/apiClient';
import { usePrivate } from '@/components/private';
import useSWRMutation from 'swr/mutation';

export const useAddCustomForm = (request: CreateCustomFormRequest) => {
  const { customFormApi } = usePrivate();

  const results = useSWRMutation(
    customFormApi,
    () => customFormApi?.apiCustomFormAddCustomFormPost(request),
    {
      onError(error) {
        console.log(
          '[BREEDLOGIC] <useAddCustomForm> error create custom form.',
          error,
        );
      },
    },
  );

  return results;
};
